import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import CelebrityList from "./CelebrityList";
import CelebrityVerification from "./CelebrityVerification";

const AdminDashboard = ({ currentScreenWidth }) => {
  const adminPanelSidebar = useSelector((state) => state.adminPanelSidebar);

  return (
    <Box
      sx={{
        marginTop: "65px",
        marginLeft:
          currentScreenWidth > 768 ? (adminPanelSidebar ? "0" : "250px") : "0",
        transition: "all 0.3s",
        padding: "10px",
      }}
    >
      <CelebrityVerification currentScreenWidth={currentScreenWidth} />
    </Box>
  );
};

export default AdminDashboard;
